import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    width: '100%',
  },
}));
